import {
  Autocomplete,
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Co2Sharp, Delete, RepeatOneSharp } from "@mui/icons-material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomButton from "../CustomComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../CustomComponents/CustomDateField";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import "./SpecialFunctionAccess.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const SpecialFunctionAccess = () => {
  const [snackBarMessage, setSnackBarMessage] = useState("range missmatch");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [emptyValueFlag, setEmptyValueFlag] = useState(false);
  const [duplicateFlag, setDuplicateFlag] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [goConfirmationDialogOpen, setGoConfirmationDialogOpen] =
    useState(false);

  const userName = useSelector((state) => state.branch.userName);
  const [moduleIdList, setModuleIdList] = useState([]);
  const [moduleHeaderList, setModuleHeaderList] = useState([]);
  const [moduleListError, setModuleListError] = useState(false);

  const [screenUserName, setScreenUserName] = useState("");
  const [userNameError, setUserNameError] = useState(false);
  const [moduleRowList, setModuleRowList] = useState([]);
  const [programRowList, setProgramRowList] = useState([]);
  const [modeRowList, setModeRowList] = useState([]);
  const [filedRowList, setFiledRowList] = useState([]);
  const [paramRowList, setParamRowList] = useState([]);
  const [fieldList, setFieldList] = useState([]);
  const [moduleModelData, setModuleModelData] = useState([]);
  const [programModelData, setProgramModelData] = useState([]);
  const [modeModelData, setModeModelData] = useState([]);
  const [fieldModelData, setFieldModelData] = useState([]);
  const [paramModelData, setParamModelData] = useState([]);
  const [modeGridEnable, setModeGridEnable] = useState(false);
  const [paramGridEnable, setParamGridEnable] = useState(false);
  const [fieldGridVisible, setFieldGridVisible] = useState(false);
  const [userAccessEnable, setUserAccessEnable] = useState(false);
  const [copyUserEnable, setCopyUserEnable] = useState(false);
  const [uploadEnable, setUploadEnable] = useState(false);
  const [uploadBtnDisable, setUploadBtnDisable] = useState(false);
  const [sourceUserName, setSourceUserName] = useState("");
  const [sourceUserNameError, setSourceUserNameError] = useState(false);
  const [destinationUserName, setDestinationUserName] = useState("");
  const [initialTemplate, setInitialTemplate] = useState("");
  const [templateValue, setTemplateValue] = useState([]);
  const [templateValueError, setTemplateValueError] = useState("");
  const [templateDisabled, setTemplateDisabled] = useState(false);
  const [downloadDisable, setDownloadDisable] = useState(false);
  const [selectedAreaRows, setSelectedAreaRows] = useState([]);

  /* 
  <MenuItem value={60}>Disbursement Access</MenuItem>
  <MenuItem value={60}>
    Disbursement Receipt Access
  </MenuItem>
  <MenuItem value={60}>
    Disbursement Receipt Vocher Access
  </MenuItem>
  <MenuItem value={60}>Disbursement Report Access</MenuItem>
  <MenuItem value={60}>Payment Access</MenuItem> */
  const [destiantionUserNameError, setDestiantionUserNameError] =
    useState(false);
  const [copyUserConfirmationOpen, setCopyUserConfirmationOpen] =
    useState(false);
  const [copyUserSuccessOpen, setCopyUserSuccessOpen] = useState(false);
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const [uploadInformationDialogOpen, setUploadInformationDialogOpen] =
    useState(false);
  const [copyUserButtonDisable, setCopyUserButtonDisable] = useState(false);
  const [uploadErrorDialogOpen, setUploadErrorDialogOpen] = useState(false);
  const [createTemplateEnable, setCreateTemplateEnable] = useState(false);
  const [uploadTemplateBtnDisable, setUploadTemplateBtnDisable] =
    useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [bulkUploadTemplateName, setBulkUploadTemplateName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [userAccessMode, setUserAccessMode] = useState(true);
  const [userAccessModeValue, setUserAccessModeValue] = useState(false);
  const [userAccessModeDisable, setUserAccessModeDisable] = useState(false);
  const [displayUserAccessMode, setDisplayUserAccessMode] = useState("none");
  const [informationPopOverEnable, setInformationPopOverEnable] =
    useState(false);
  const branchUserName = useSelector((state) => state.branch.userName);

  //shortcut key
  const dispatch = useDispatch();
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const saveCopyRef = useRef(null);
  const clearCopyRef = useRef(null);
  const downloadCopyRef = useRef(null);
  const uploadCopyRef = useRef(null);
  const downloadTemplateRef = useRef(null);
  const uploadTemplateRef = useRef(null);
  const downloadBulkRef = useRef(null);
  const uploadBulkRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "specialAcess",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      clearRef: clearRef.current !== null ? clearRef : null,
      searchButtonRef:
        searchButtonRef.current !== null ? searchButtonRef : null,
      saveRef: saveRef.current !== null ? saveRef : null,
      saveCopyRef: saveCopyRef.current !== null ? saveCopyRef : null,
      clearCopyRef: clearCopyRef.current !== null ? clearCopyRef : null,
      downloadCopyRef:
        downloadCopyRef.current !== null ? downloadCopyRef : null,
      uploadCopyRef: uploadCopyRef.current !== null ? uploadCopyRef : null,
      downloadTemplateRef:
        downloadTemplateRef.current !== null ? downloadTemplateRef : null,
      uploadTemplateRef:
        uploadTemplateRef.current !== null ? uploadTemplateRef : null,
      downloadBulkRef:
        downloadBulkRef.current !== null ? downloadBulkRef : null,
      uploadBulkRef: uploadBulkRef.current !== null ? uploadBulkRef : null,
    };
    if (event.key === "Escape" || event.keyCode === 27) {
      setSaveDialogOpen(false);
      setSaveSuccessDialogOpen(false);
      setErrorDialogOpen(false);
      setGoConfirmationDialogOpen(false);
      setCopyUserConfirmationOpen(false);
      setUploadInformationDialogOpen(false);
      setUploadErrorDialogOpen(false);
      setCopyUserSuccessOpen(false);
      setErrorDialogOpen(false);
    } else if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "specialAcess",
        })
      );
    }
  };

  const moduleColumns = [
    {
      field: "mdId",
      headerName: "MDID",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "tempId",
      headerName: "tempId",
      type: "string",
      hide: true,
    },
    {
      field: "userName",
      headerName: "User Name",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "userId",
      headerName: "User Name",
      headerAlign: "center",
      align: "left",
      flex: 250,
      type: "string",
      hide: true,
    },
    {
      field: "moduleName",
      headerName: "Module Name",
      headerAlign: "center",
      align: "left",
      flex: 285,
      type: "string",
    },
    {
      field: "moduleId",
      headerName: "Module Id",
      headerAlign: "center",
      align: "left",
      flex: 195,
      type: "string",
    },
    {
      field: "isSpecial",
      headerName: "Module Access",
      headerAlign: "center",
      align: "left",
      flex: 150,
      editable: true,
      type: "singleSelect",
      valueOptions: ["True", "False"],
      /*  renderCell: (record) => {
        return (
          <Switch
            checked={moduleAccess}
            onChange={(value) =>
              getProgramValues(value.target.checked, record.row)
            }
          ></Switch>
        );
      }, */
    },
  ];
  let programColumn = [
    {
      field: "pmId",
      headerName: "PMID",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "programName",
      headerName: "Program Name",
      headerAlign: "center",
      align: "left",
      flex: 285,
      type: "string",
    },
    {
      field: "programId",
      headerName: "Program Id",
      headerAlign: "center",
      align: "left",
      flex: 195,
      type: "string",
    },
    {
      field: "programAccess",
      headerName: "Program Access",
      headerAlign: "center",
      align: "left",
      flex: 140,
      type: "singleSelect",
      editable: true,
      valueOptions: ["True", "False"],
      /*  renderCell: (record) => {
        return (
          <Switch
            checked={programAccess}
            onChange={(value) =>
              getModeValues(value.target.checked, record.row)
            }
          ></Switch>
        );
      }, */
    },
  ];
  let modeColumn = [
    {
      field: "meId",
      headerName: "MeID",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "modeName",
      headerName: "Mode Name",
      headerAlign: "center",
      align: "left",
      flex: 285,
      type: "string",
    },
    {
      field: "modeId",
      headerName: "Mode Id",
      headerAlign: "center",
      align: "left",
      flex: 195,
      type: "string",
    },
    {
      field: "modeAccess",
      headerName: "Mode Access",
      headerAlign: "center",
      align: "left",
      flex: 140,
      type: "singleSelect",
      editable: true,
      valueOptions: ["True", "False"],

      /*  renderCell: (record) => {
        return (
          <Switch onChange={(value) => getFieldValues(value, record)}></Switch>
        );
      }, */
    },
  ];

  const fieldColumn = [
    {
      field: "fId",
      headerName: "FID",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "fieldName",
      headerName: "Field Name",
      headerAlign: "center",
      align: "left",
      flex: 296,
      type: "string",
    },
    {
      field: "fieldId",
      headerName: "Field Id",
      headerAlign: "center",
      align: "left",
      flex: 200,
      type: "string",
    },
    {
      field: "fieldType",
      headerName: "Field Type",
      headerAlign: "center",
      align: "left",
      type: "string",
      hide: true,
    },

    {
      field: "fieldAccess",
      headerName: "Field Access",
      headerAlign: "center",
      align: "left",
      flex: 100,
      type: "singleSelect",
      editable: true,
      valueOptions: ["True", "False"],
      /*  renderCell: (record) => {
        return (
          <Switch onChange={(value) => getParamValues(value, record)}></Switch>
        );
      }, */
    },
  ];
  const [fieldColumnList, setFieldColumnList] = useState(fieldColumn);
  //param definition
  const paramColumn = [
    {
      field: "fId",
      headerName: "FID",
      headerAlign: "center",
      align: "left",
      flex: 300,
      type: "string",
      hide: true,
    },
    {
      field: "paramName",
      headerName: "Param Name",
      headerAlign: "center",
      align: "left",
      flex: 296,
      type: "string",
    },
    {
      field: "paramId",
      headerName: "Param Id",
      headerAlign: "center",
      align: "left",
      flex: 150,
      type: "string",
    },

    {
      field: "paramAccess",
      headerName: "Param Access",
      headerAlign: "center",
      align: "left",
      flex: 150,
      type: "singleSelect",
      editable: true,
      valueOptions: ["True", "False"],
      /* renderCell: (record) => {
        return (
          <Switch onChange={(value) => setMapToSave(value, record)}></Switch>
        );
      }, */
    },
  ];
  const downloadTemplateColumns = [
    {
      field: "id",
      headerName: "Id",
      headerAlign: "center",
      align: "left",
      flex: 296,
      type: "string",
      hide: true,
    },
    {
      field: "userId",
      headerName: "User Id",
      headerAlign: "center",
      align: "left",
      flex: 196,
      type: "string",
    },
    {
      field: "templateId",
      headerName: "Template",
      headerAlign: "center",
      align: "left",
      flex: 296,
      type: "singleSelect",
      editable: true,
      valueOptions: ["Full_Access", "Partial_Access", "Delete_Access"],
    },
  ];
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);

  const [gridVisible, setGridVisible] = useState(false);
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [saveSuccessDialogOpen, setSaveSuccessDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] =
    useState("Failed to Upload");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [moduleName, setModuleName] = useState("");
  const [disableModule, setDisableModule] = useState(false);
  const [programGridVisible, setProgramGridVisible] = useState(false);
  const [moduleIdValue, setModuleIdValue] = useState("");
  const [confiramtionDialogFlag, setConfiramtionDialogFlag] = useState(true);
  const [userArray, setUserArray] = useState([]);

  /* Function started */

  useEffect(() => {
    getUserValues();
    getTemplateValues();
  }, [userAccessEnable, uploadEnable]);
  const getUserValues = async () => {
    const userIdsresponse = await axios.post("/api/getUserLov", {
      apiCode: "USER_LOV_API",
      createdBy: "",
      requestBody: {},
    });
    if (userIdsresponse.data.status === 1) {
      const responseData = userIdsresponse.data;
      const usersData = responseData["user_details"];
      const userIds = [...usersData].map((user) => user.userid);
      setUserArray([...userIds]);
    } else {
      // failure response.
      setUserArray([]);
    }
  };
  const getTemplateValues = async () => {
    const response = await axios.get("/specialAccess/loadTempalteValues");
    const overallData = response.data;
    setTemplateValue(overallData);
  };
  const getModuleValues = async (data, newValue) => {
    //setSaveDisabled(false);
    if (newValue === null) {
      setScreenUserName("");
      setUserNameError(true);
      setModuleName("");
      setInitialTemplate("");
      setSaveDisabled(true);
      setModuleIdValue("");
      setGridVisible(false);
    } else {
      let moduleIdList = [];
      let moduleNameList = [];
      let templateIdList = [];
      let templateNameList = [];
      let userId = newValue;
      setScreenUserName(userId);
      setModuleName("");
      setInitialTemplate("");

      const response = await axios.get("/specialAccess/loadModuleList", {
        method: "get",
        params: {
          userId: userId,
        },
      });
      const overallData = response.data;
      const outputData = overallData["module"];
      outputData.forEach((outputDatas) => {
        Object.entries(outputDatas).map(([key, value]) => {
          moduleIdList.push(key);
          moduleNameList.push(value);
        });
      });
      setModuleIdList(outputData);
      setModuleHeaderList(moduleNameList);
    }
    /*  const tempalteData = overallData["template"];
    tempalteData.forEach((tempalte) => {
      templateNameList.push(tempalte.templateId);
    });
    setTemplateValue(templateNameList); */
  };

  const getModuleNameDetails = (event, newValue) => {
    setDisplayUserAccessMode("none");
    if (newValue !== null) {
      setUserAccessModeValue("Append");
      setUserAccessModeDisable(true);
      setTemplateDisabled(true);
      setInitialTemplate("");
      setUserAccessMode(true);
      setModuleName(newValue);
    } else {
      setUserAccessModeValue("Fresh");
      setUserAccessModeDisable(false);
      setTemplateDisabled(false);
      setModuleName("");
      setUserAccessMode(false);
      setSaveDisabled(true);
      setGridVisible(false);
      setDiscardDialogOpen(false);
      setGoConfirmationDialogOpen(false);
      setConfiramtionDialogFlag(true);
      setTemplateDisabled(false);
      setDisableModule(false);
      // setInitialTemplate("");
      setModuleIdValue("");
    }
  };
  const onSaveButtonClickHandler = async () => {
    setSaveDialogOpen(false);
    let modeMap = {};
    modeMap["headerData"] = moduleModelData ? moduleModelData : [];
    modeMap["programData"] = programModelData ? programModelData : [];
    modeMap["modeData"] = modeModelData ? modeModelData : [];
    modeMap["fieldData"] = fieldModelData ? fieldModelData : [];
    modeMap["paramData"] = paramModelData ? paramModelData : [];
    modeMap["userId"] = screenUserName;
    modeMap["moduleId"] = moduleIdValue;
    modeMap["templateId"] = initialTemplate;
    modeMap["userAccessType"] = userAccessMode;
    modeMap["branchUserName"] = userName;
    const response = await axios.post(
      "/specialAccess/setModuleDetails",
      modeMap
    );
    if (response.status === 200) {
      setSaveSuccessDialogOpen(true);
    }
  };

  const goButtonAction = () => {
    if (!screenUserName) {
      discardChange();
      setUserNameError(true);
    } else {
      getModuleDetail();
      setUserNameError(false);
      setGoConfirmationDialogOpen(false);
    }
  };
  const handleSearch = () => {
    if (confiramtionDialogFlag) {
      setGoConfirmationDialogOpen(false);
      goButtonAction();
    } else {
      setGoConfirmationDialogOpen(true);
    }
  };

  const getModuleDetail = async () => {
    try {
      let localModuleIdValue = "";
      moduleIdList.map((module) => {
        if (module) {
          Object.keys(module).map(async (key) => {
            if (module[key] === moduleName) {
              setModuleIdValue(key);
              localModuleIdValue = key;
            }
          });
        }
      });
      const response = await axios.get("/specialAccess/loadModuleGridList", {
        method: "get",
        params: {
          userId: screenUserName,
          templateId: initialTemplate,
          moduleId: localModuleIdValue,
        },
      });
      const overallData = response.data;
      const outputData = overallData["header"];
      let updatedData = outputData.map((data) => {
        data.createdBy = userName;
        data.lastUpdatedBy = userName;
        return data;
      });
      setModuleRowList(outputData);
      setGridVisible(true);
      setModuleModelData(updatedData);
      getProgramValuesInitialLoad(overallData, localModuleIdValue);
      if (initialTemplate !== "" && localModuleIdValue === "") {
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const clearButtonClickHandler = () => {
    if (!saveDisabled) {
      setDiscardDialogOpen(true);
    } else {
      discardChange();
    }
  };
  const getProgramValuesInitialLoad = async (data, moduleIdValue) => {
    let programList = data["program"];
    let moduleList = data["header"];
    let moduleDataList = [];
    let moduleIdList = [];
    if (Array.isArray(moduleList)) {
      moduleList.map((module) => {
        if (module.isSpecial === "True") {
          moduleIdList.push(module.moduleId);
        }
        moduleDataList.push(module.isSpecial);
      });
    }

    if (
      (moduleIdList.length === 1 && moduleIdList[0] === "MD003") ||
      (moduleIdList.length === 1 && moduleIdList[0] === "MD013") ||
      (moduleIdList.length === 1 && moduleIdList[0] === "MD014") ||
      (moduleIdList.length === 1 && moduleIdList[0] === "MD015") ||
      (moduleIdList.length === 1 && moduleIdList[0] === "MD009") ||
      (programList.length === 0 &&
        moduleIdList.includes("MD003", "MD013", "MD014", "MD015", "MD009"))
    ) {
      setProgramGridVisible(false);
      getFieldValuesInitialLoad(moduleList, null, null, moduleIdValue);
    } else {
      setProgramGridVisible(true);
      setProgramRowList(programList);
      getModeValuesInitialLoad(moduleList, programList, moduleIdValue);
    }
    if (!moduleDataList.includes("True")) {
      setProgramGridVisible(false);
      setProgramModelData([]);
      setProgramRowList([]);
      setModeGridEnable(false);
      setModeModelData([]);
      setModeRowList([]);
      setFieldGridVisible(false);
      setFiledRowList([]);
      setFieldModelData([]);
      setParamGridEnable(false);
      setParamRowList([]);
      setParamModelData([]);
    }
    setProgramModelData(programList);
  };
  //enable programs
  const getProgramValues = async (data) => {
    let programList = [];
    let moduleDataMap = {};
    let moduleDataList = [];
    let access = data.value === "True" ? true : false;
    let mdId = "0";
    let tempId = "0";
    let oldProgramList = programRowList;
    let oldModuleRowList = moduleRowList;
    // setModuleIdValue(data.id);
    setSaveDisabled(false);
    setConfiramtionDialogFlag(false);
    if (access) {
      switch (data.id) {
        case "MD003":
          if (programRowList.length === 0) {
            setProgramGridVisible(false);
          }
          break;
        case "MD013":
          if (programRowList.length === 0) {
            setProgramGridVisible(false);
          }
          break;
        case "MD009":
          if (programRowList.length === 0) {
            setProgramGridVisible(false);
          }
          break;
        case "MD014":
          if (programRowList.length === 0) {
            setProgramGridVisible(false);
          }
          break;
        case "MD015":
          if (programRowList.length === 0) {
            setProgramGridVisible(false);
          }
          break;
        default:
          setProgramGridVisible(true);
          break;
      }
      let oldModuleList = oldModuleRowList.filter(
        (oldMd) => oldMd.moduleId === data.id
      );
      const response = await axios.get("/specialAccess/loadProgramGridList", {
        method: "get",
        params: {
          userId: screenUserName,
          moduleId: data.id,
          mdId: oldModuleList[0].mdId,
          tempId: tempId,
          templateId: initialTemplate,
        },
      });
      programList = response.data;
      let updatedList = programList.map((program) => {
        program.createdBy = userName;
        program.lastUpdatedBy = userName;
        return program;
      });
      setProgramRowList([...oldProgramList, ...updatedList]);
      setProgramModelData(updatedList);
      getModeValuesInitialLoad(
        moduleModelData,
        [...oldProgramList, ...updatedList],
        data.id
      );
    } else {
      let updatePrgList = oldProgramList.filter(
        (prg) => prg.moduleId !== data.id
      );
      let updatemoduleList = moduleModelData.filter(
        (md) => md.moduleId !== data.id
      );
      if (updatePrgList.length === 0) {
        setProgramGridVisible(false);
        setProgramModelData([]);
        setProgramRowList([]);
        setModeGridEnable(false);
        setModeModelData([]);
        setModeRowList([]);
        setFieldGridVisible(false);
        setFiledRowList([]);
        setFieldModelData([]);
        setParamGridEnable(false);
        setParamRowList([]);
        setParamModelData([]);
      } else {
        setProgramModelData(updatePrgList);
        getModeValuesInitialLoad(updatemoduleList, updatePrgList, data.id);
        setProgramRowList(updatePrgList);
      }
    }

    moduleDataList = oldModuleRowList.map((module) => {
      if (module.moduleId === data.id) {
        module.isSpecial = data.value;
      }
      return module;
    });
    setModuleModelData(moduleDataList);
  };
  const getModeValuesInitialLoad = async (moduleData, data, moduleId) => {
    let programMap = [];
    let programList = modeRowList;
    let programModelDataList = programRowList;
    let datase = programRowList;

    let modeList = [];
    let accessList = [];
    let moduleValue;

    let pmIdList = [];
    let programIdList = [];
    let moduleIdList = [];
    let targetAccessList = [];
    let userIdList = [];

    if (Array.isArray(data)) {
      data.map((program) => {
        userIdList.push(program.userId);
        if (program.programAccess === "True") {
          pmIdList.push(program.pmId);
          programIdList.push(program.programId);
        }
        moduleIdList.push(program.moduleId);
        targetAccessList.push(program.programAccess);
      });
      moduleValue = moduleIdList[0];
    }
    if (!moduleIdList.includes("MD001")) {
      setModeGridEnable(false);
      setModeRowList([]);
      getFieldValuesInitialLoad(moduleData, data, null, moduleIdValue);
      // setFieldGridVisible(true);
      //getFieldValuesInitialLoad(data);
    } else {
      let paramValue = {
        userId: screenUserName,
        templateId: initialTemplate,
        moduleId: moduleId,
        pmIdList: pmIdList,
        programIdList: programIdList,
      };
      const response = await axios.post(
        "/specialAccess/loadModeGridListIntial",
        paramValue
        /*  {
          method: "post",
          params: { paramValue },
        } */
      );
      programMap = response.data;

      if (programMap.length > 0) {
        setModeGridEnable(true);
        setModeRowList(response.data);
      }
      getFieldValuesInitialLoad(moduleData, data, programMap, moduleIdValue);
    }
    setModeModelData(programMap);
  };
  const getFieldValuesInitialLoad = async (
    moduleData,
    programData,
    modeDatas,
    moduleId
  ) => {
    let programMap = {};
    let programIdList = [];
    let modeIdList = [];
    let meIdList = [];
    let pmIdList = [];
    let moduleIdsList = [];
    let disabledPmIdList = [];
    let updateDisabledPmIdList = [];
    let updateDisableMdIdList = [];
    let disableMdIdList = [];
    let moduleList = [];

    let modeData =
      modeDatas !== null && modeDatas.length > 0
        ? modeDatas
        : modeDatas !== null
        ? modeRowList
        : [];
    let oldfieldRowList = filedRowList;
    let oldPramRowList = paramRowList;

    let mdIdList = [];
    let modeAccessMap = {};
    if (Array.isArray(modeData)) {
      modeData.map((program) => {
        moduleList.push(program.moduleId);
        if (program.modeAccess) {
          if (program.modeAccess === "True") {
            modeIdList.push(program.modeId);
            meIdList.push(program.meId);
            programIdList.push(program.programId);
          } else {
            if (!programIdList.includes(program.programId)) {
              disabledPmIdList.push(program.programId);
            }
          }
        } else {
          if (program.programAccess === "True") {
            programIdList.push(program.programId);
          }
        }
      });
      disabledPmIdList.map((disablePm) => {
        if (!programIdList.includes(disablePm)) {
          updateDisabledPmIdList.push(disablePm);
        }
      });
    }
    let programModuleIdList = [];
    let programIdValueList = [];
    if (Array.isArray(programData)) {
      programData.map((program) => {
        moduleList.push(program.moduleId);
        if (
          /*   programIdList.length > 0 &&
          !programIdList.includes(program.programId) && */
          !updateDisabledPmIdList.includes(program.programId)
        ) {
          programModuleIdList.push(program.moduleId);
          if (program.programAccess === "True") {
            programIdValueList.push(program.programId);
            pmIdList.push(program.pmId);
          }
        }
      });
    }

    if (Array.isArray(moduleData)) {
      moduleData.map((module) => {
        if (
          /*   programIdList.length > 0 &&
          !programIdList.includes(program.programId) && */
          !moduleList.includes(module.moduleId)
        ) {
          if (module.moduleAccess === "True" || module.isSpecial === "True") {
            moduleIdsList.push(module.moduleId);
            mdIdList.push(module.mdId);
          }
        }
      });
    }
    if (programData === null && modeDatas === null && moduleId !== "") {
      moduleIdsList.push(moduleId);
    }

    let outputFieldData = [];
    let outputParamData = [];
    let paramMap = {
      userId: screenUserName,
      templateId: initialTemplate,
      moduleIdList: moduleIdsList,
      mdIdList: mdIdList,
      moduleId: moduleId,
      meIdList: meIdList,
      pmIdList: pmIdList,
      modeIdList: modeIdList,
      programIdList: programIdValueList,
      existFieldList: oldfieldRowList,
    };
    const response = await axios.post(
      "/specialAccess/loadFieldListInitial",
      paramMap
    );
    programMap = response.data;
    outputFieldData = programMap["field"];
    outputParamData = programMap["param"];
    if (outputFieldData && outputFieldData.length > 0) {
      setFieldGridVisible(true);
      setFiledRowList(outputFieldData);
      setFieldModelData(outputFieldData);
    } else {
      let existFieldList = [];
      oldfieldRowList.map((oldField) => {
        if (
          programIdList.length > 0 &&
          oldField.programId.includes(programIdList)
        ) {
          existFieldList.push(oldField);
        }
      });
      if (existFieldList.length === 0) {
        setFieldGridVisible(false);
        setFiledRowList([]);
      } else {
        setFiledRowList(existFieldList);
      }
    }
    if (outputParamData && outputParamData.length > 0) {
      setParamGridEnable(true);
      setParamRowList(outputParamData);
      setParamModelData(outputParamData);
    } else {
      let existParamList = [];
      oldPramRowList.map((oldField) => {
        if (
          programIdList.length > 0 &&
          oldField.programId.includes(programIdList)
        ) {
          existParamList.push(oldField);
        }
      });
      if (existParamList.length === 0) {
        setParamRowList([]);
        setParamGridEnable(false);
      } else {
        setParamRowList(existParamList);
      }
    }

    // getParamValuesInitialLoad(outputFieldData);
  };
  const getParamValuesInitialLoad = async (data) => {
    let paramMap = {};
    let fieldIdList = [];
    let fdIdList = [];
    let userIdList = [];
    let moduleIdList = [];
    let outputParamData = [];
    if (Array.isArray(data)) {
      data.map((field) => {
        userIdList.push(field.userId);
        if (field.fieldAccess === "True") {
          fieldIdList.push(field.fieldId);
          fdIdList.push(field.fdId);
        }
        moduleIdList.push(field.moduleId);
      });
    }

    if (fieldIdList.length > 0) {
      const response = await axios.get(
        "/specialAccess/loadParamListInitialLoad",
        {
          params: fdIdList,
        }
      );
      paramMap = response.data;
      setParamGridEnable(true);
      setParamRowList(paramMap);
    } else {
      setParamRowList([]);
    }
  };
  //enable Mode
  const getModeValues = async (data) => {
    let programMap = [];
    let programList = modeRowList;
    let programModelDataList = programRowList;
    let prgId = data.id;
    const targetAccess = data.value === "True" ? true : false;
    setSaveDisabled(false);
    setConfiramtionDialogFlag(false);
    if (
      initialTemplate === "" &&
      !prgId.includes("DB0") &&
      programList.length === 0
    ) {
      setModeGridEnable(false);
      //setFieldGridVisible(true);
      getFieldValues(data);
    } else {
      if (targetAccess) {
        if (!prgId.includes("DB0")) {
          if (programModelDataList.length === 1) {
            setModeGridEnable(false);
          }
          setFieldGridVisible(true);
          let newProgramList = programModelDataList.filter(
            (prg) => prg.programId === data.id
          );
          let newData = programModelDataList.map((item) => {
            if (item.programId === data.id) {
              item.programAccess = data.value;
            }
            return item;
          });
          getFieldValuesInitialLoad(
            moduleModelData,
            newData,
            modeRowList,
            moduleIdValue
          );
        } else {
          setModeGridEnable(true);
          let programModel = programModelDataList.filter(
            (prg) => prg.programId === data.id
          );

          let pmId = programModel[0].pmId;
          const response = await axios.get("/specialAccess/loadModeGridList", {
            method: "get",
            params: {
              userId: screenUserName,
              moduleId: moduleIdValue,
              programId: data.id,
              templateId: initialTemplate,
              pmId: pmId,
            },
          });
          programMap = response.data;
          setModeRowList([...programList, ...programMap]);
          let newData = programModelDataList.map((item) => {
            if (item.programId === data.id) {
              item.programAccess = data.value;
            }
            return item;
          });
          getFieldValuesInitialLoad(
            moduleModelData,
            newData,
            [...programList, ...programMap],
            moduleIdValue
          );
        }
      } else {
        programMap = programList.filter(
          (program) => program.programId !== data.id
        );
        if (programMap.length === 0) {
          setModeGridEnable(false);
          setFieldGridVisible(false);
          setFiledRowList([]);
          setModeRowList([]);
          setParamGridEnable(false);
          setModeModelData([]);
          setFieldModelData([]);
          setParamModelData([]);
        } else {
          let newProgramList = programModelDataList.filter(
            (prg) => prg.programId !== data.id
          );
          setModeRowList(programMap);
          getFieldValuesInitialLoad(
            moduleModelData,
            newProgramList,
            programMap,
            moduleIdValue
          );
        }
      }
    }

    let newData = programModelDataList.map((item) => {
      if (item.programId === data.id) {
        item.programAccess = data.value;
      }
      item.createdBy = userName;
      item.lastUpdatedBy = userName;
      return item;
    });
    let updatedProgramMap = programMap.map((program) => {
      program.createdBy = userName;
      program.lastUpdatedBy = userName;
      return program;
    });
    setProgramModelData(newData);
    setModeModelData([...modeRowList, ...updatedProgramMap]);
  };

  //enable fields
  const getFieldValues = async (data) => {
    let modeRowListData;
    let fieldMap;
    setSaveDisabled(false);
    setConfiramtionDialogFlag(false);
    let oldparamRowList = paramRowList ? paramRowList : [];
    if (modeRowList.length > 0) {
      modeRowListData = modeRowList.filter((mode) => mode.modeId === data.id);
      let programData = programRowList.filter(
        (prg) => prg.programId === modeRowListData[0].programId
      );
      let mdIdList = moduleRowList.filter(
        (md) => md.mdId === programData[0].mdId
      );
      fieldMap = {
        userId: screenUserName,
        moduleId: moduleIdValue,
        programId: modeRowListData[0].programId,
        modeId: data.id,
        templateId: initialTemplate,
        pmId: modeRowListData[0].pmId,
        meId: modeRowListData[0].meId,
        mdId: mdIdList[0].mdId,
      };
    } else {
      modeRowListData = programRowList.filter(
        (mode) => mode.programId === data.id
      );
      fieldMap = {
        userId: screenUserName,
        moduleId: moduleIdValue,
        programId: data.id,
        templateId: initialTemplate,
        pmId: modeRowListData[0].pmId,
        mdId: modeRowListData[0].mdId,
      };
    }

    let fieldMapList = filedRowList
      ? filedRowList.map((fild) => {
          fild.fieldAccess =
            fild.fieldAccess === true || fild.fieldAccess === "True"
              ? "True"
              : "False";
          return fild;
        })
      : [];
    let paramMapList = paramRowList
      ? paramRowList.map((fild) => {
          fild.fieldAccess =
            fild.paramAccess === true || fild.paramAccess === "True"
              ? "True"
              : "False";
          return fild;
        })
      : [];
    let programMap = {};
    let paramMap = {};
    let modeModelDataList = modeRowList;
    let targetAccess = data.value === "True" ? true : false;
    if (targetAccess) {
      // setFieldGridVisible(true);
      const response = await axios.get("/specialAccess/loadFieldList", {
        method: "get",
        params: fieldMap,
      });
      let outputData = response.data;
      programMap = outputData["field"];
      let paramMap = outputData["param"];

      if (fieldMapList.length === 0 && programMap.length === 0) {
        setFieldGridVisible(false);
        setFiledRowList([]);
        setParamGridEnable(false);
        setParamRowList([]);
      } else {
        setFieldGridVisible(true);
        programMap = programMap.map((prg) => {
          prg.fieldAccess =
            prg.fieldAccess === true || prg.fieldAccess === "True"
              ? "True"
              : "False";
          return prg;
        });
        setFiledRowList([...fieldMapList, ...programMap]);
        if (oldparamRowList.length === 0 && paramMap.length === 0) {
          setParamGridEnable(false);
        } else {
          setParamGridEnable(true);
          programMap = paramMap.map((prg) => {
            prg.fieldAccess =
              prg.fieldAccess === true || prg.fieldAccess === "True"
                ? "True"
                : "False";
            return prg;
          });
          setParamRowList([...oldparamRowList, ...paramMap]);
        }
      }

      //getParamValuesInitialLoad([...fieldMapList, ...programMap]);
    } else {
      if (moduleIdValue !== "" && !data.id.includes("DB0")) {
        programMap = fieldMapList.filter(
          (field) => field.programId !== data.id
        );
        paramMap = paramMapList.filter((field) => field.programId !== data.id);
      } else {
        programMap = fieldMapList.filter((field) => field.modeId !== data.id);
        paramMap = paramMapList.filter((field) => field.modeId !== data.id);
      }
      if (programMap.length === 0) {
        setFiledRowList([]);
        setParamRowList([]);
        setFieldGridVisible(false);
        setParamGridEnable(false);
      } else {
        setFieldGridVisible(true);
        /*  programMap = programMap.map((prg) => {
          prg.fieldAccess = prg.fieldAccess === true ? "True" : "False";
          return prg;
        }); */
        setFiledRowList(programMap);
      }
      if (paramMap.length === 0) {
        setParamGridEnable(false);
      } else {
        setParamGridEnable(true);
        /*  paramMap = paramMap.map((prg) => {
          prg.fieldAccess = prg.paramAccess === true ? "True" : "False";
          return prg;
        }); */
        setParamRowList(paramMap);
      }

      //getParamValuesInitialLoad(programMap);
    }

    let newData = modeModelDataList.map((item) => {
      if (item.modeId === data.id) {
        item.modeAccess = data.value;
      }
      item.createdBy = userName;
      item.lastUpdatedBy = userName;
      return item;
    });
    let updatedProgramMap = programMap.map((program) => {
      program.createdBy = userName;
      program.lastUpdatedBy = userName;
      return program;
    });
    setModeModelData(newData);
    setFieldModelData([...fieldMapList, ...updatedProgramMap]);
  };
  //enable params
  const getParamValues = async (data) => {
    setSaveDisabled(false);
    setConfiramtionDialogFlag(false);
    let fieldRowListData = filedRowList.filter(
      (field) => field.fieldId === data.id
    );
    let fieldMap = {
      userId: screenUserName,
      moduleId: moduleIdValue,
      programId: fieldRowListData[0].programId,
      modeId: fieldRowListData[0].modeId,
      fieldId: data.id,
      templateId: initialTemplate,
      pmId: fieldRowListData[0].pmId,
      meId: fieldRowListData[0].meId,
      fieldAccess: data.value,
    };
    let paramList = paramRowList;
    let fieldModelDataList = filedRowList;
    let paramMap = {};
    const targetAccess = data.value === "True" ? true : false;
    if (targetAccess) {
      const response = await axios.get("/specialAccess/loadFieldList", {
        method: "get",
        params: fieldMap,
      });
      let outputData = response.data;
      paramMap = outputData["param"];
      if (paramMap.length > 0) {
        let updatedParamMap = paramMap.map((param) => {
          param.createdBy = userName;
          param.lastUpdatedBy = userName;
          return param;
        });
        if (paramMap.length === 0) {
          setParamGridEnable(false);
        }
        setParamGridEnable(true);
        setParamRowList([...paramList, ...updatedParamMap]);
        setParamModelData([...paramList, ...updatedParamMap]);
      }
    } else {
      paramMap = paramList
        .filter((field) => field.fieldId !== data.id)
        .map((fieldMap) => {
          fieldMap.createdBy = userName;
          fieldMap.lastUpdatedBy = userName;
          return fieldMap;
        });
      if (paramMap.length === 0) {
        setParamGridEnable(false);
      }
      setParamRowList(paramMap);
      setParamModelData(paramMap);
      //  setParamModelData([...paramList, ...paramMap]);
    }

    let newData = fieldModelDataList.map((item) => {
      if (item.fieldId === data.id) {
        item.fieldAccess = targetAccess;
      }
      item.createdBy = userName;
      item.lastUpdatedBy = userName;
      return item;
    });
    setFieldModelData(newData);
  };
  const setMapToSave = (data) => {
    setSaveDisabled(false);
    let paramList = paramModelData;
    let fieldData = paramRowList;
    let paramId = data.id;
    let targetAccess = data.value === "True" ? true : false;
    //paramMap.paramAccess = targetAccess;

    let newData = fieldData.map((item) => {
      if (item.paramId === data.id) {
        item.paramAccess = data.value;
      }
      item.createdBy = userName;
      item.lastUpdatedBy = userName;
      return item;
    });
    let fieldDataList = [];
    let fielda = false;
    let updateFieldData = filedRowList;
    let paramData = newData;
    let currentParmaData = paramRowList.filter((pa) => pa.paramId === data.id);
    newData
      .filter((cr) => cr.paramId === data.id)
      .forEach((datas) => {
        if (datas.paramAccess === "false") {
          fielda = fieldList.some((elem) => elem === datas.fieldId);
          if (!fielda) {
            fieldDataList.push(datas.fieldId);
            setFieldList(fieldDataList);
          } else {
            updateFieldData = filedRowList
              //.filter((fi) => fi.paramId === data.id)
              .map((field) => {
                if (datas.fieldId === field.fieldId) {
                  field.fieldAccess = targetAccess;
                }
                field.createdBy = userName;
                field.lastUpdatedBy = userName;
                //  if (currentParmaData > 0) {
                paramData = newData
                  .filter((field) => field.fieldId !== datas.fieldId)
                  .map((param) => {
                    param.createdBy = screenUserName;
                    param.lastUpdatedBy = screenUserName;
                    return param;
                  });
                return field;
                // }
              });
          }
        } else {
        }
      });
    if (paramData.length === 0) {
      setParamGridEnable(false);
    }
    setFiledRowList(updateFieldData);
    setParamRowList(paramData);
    setFieldModelData(updateFieldData);
    setParamModelData(newData);
  };
  //save action
  const saveData = async () => {
    setSaveDialogOpen(true);
  };

  const discardChange = () => {
    setSaveDisabled(true);
    setGridVisible(false);
    setDiscardDialogOpen(false);
    setGoConfirmationDialogOpen(false);
    setConfiramtionDialogFlag(true);
    setTemplateDisabled(false);
    setDisableModule(false);
    setInitialTemplate("");
    setModuleName("");
    setScreenUserName("");
    setModuleIdValue("");
    setModuleIdList([]);
    setModuleHeaderList([]);
    setUserAccessModeDisable(false);
    setUserAccessMode(false);
    setUserNameError(false);
  };

  const getUserAccessDetails = (event) => {
    const enalbeswitch = event.target.checked;
    setUserAccessEnable(enalbeswitch);
    setCopyUserEnable(false);
    setUploadEnable(false);
    setCreateTemplateEnable(false);
  };

  const copyUserDetail = (event) => {
    const enalbeswitch = event.target.checked;
    setCopyUserEnable(enalbeswitch);
    setUserAccessEnable(false);
    setUploadEnable(false);
    setCreateTemplateEnable(false);
  };

  const downloadCopyValuesTemplate = () => {
    try {
      axios
        .get("/specialAccessUpload/downloadCopyValuesTemplate", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `SpecialAccess_Copy.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          /*  setMessage("Nach Inward Sample Import File Downloaded Success.");
          setAlertType("success");
          openAlertHandler(); */
        })
        .then(() => {
          setUploadBtnDisable(false);
        });
    } catch (error) {
      /*  setMessage("Nach Inward Sample Import File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler(); */
      throw Error(error);
    }
  };

  const uploadAccessDetail = (event) => {
    const enalbeswitch = event.target.checked;
    setUploadEnable(enalbeswitch);
    setUserAccessEnable(false);
    setCopyUserEnable(false);
    setCreateTemplateEnable(false);
  };
  const createTemplateAccessDetail = (event) => {
    const enalbeswitch = event.target.checked;
    setCreateTemplateEnable(enalbeswitch);
    setUploadEnable(false);
    setUserAccessEnable(false);
    setCopyUserEnable(false);
  };
  const getSourceUserName = (event, value) => {
    if (value !== null) {
      setSourceUserName(value);
      setSourceUserNameError(false);
    } else {
      setSourceUserName("");
    }
  };
  const getDestinationUser = (event, value) => {
    if (value !== null) {
      setDestinationUserName(value);
      setDestiantionUserNameError(false);
    } else {
      setDestinationUserName("");
    }
  };

  const getTemplateUser = (event, value) => {
    if (value !== null) {
      setDisableModule(true);
      setTemplateValueError(false);
      setModuleName("");
      setInitialTemplate(value);
      setDisplayUserAccessMode("flex");
      setUserAccessMode(true);
      setUserAccessModeValue("Append");
      setUserAccessModeDisable(false);
    } else {
      setDisableModule(false);
      setInitialTemplate("");
      setDisplayUserAccessMode("none");
      setUserAccessMode(false);
      setUserAccessModeValue("fresh");
      setUserAccessModeDisable(false);
      setSaveDisabled(true);
      setGridVisible(false);
      setDiscardDialogOpen(false);
      setGoConfirmationDialogOpen(false);
      setConfiramtionDialogFlag(true);
      setTemplateDisabled(false);
    }
  };

  const bulkUploadTemplateUser = (event, value) => {
    if (value !== null) {
      setBulkUploadTemplateName(value);
    } else {
      setBulkUploadTemplateName("");
    }
  };
  const clearUserAccessDetail = (event) => {
    setSourceUserName("");
    setDestinationUserName("");
    setDestiantionUserNameError(false);
    setSourceUserNameError(false);
  };
  const getTemplateInfo = (event) => {
    setInformationPopOverEnable(event.currentTarget);
  };
  const infoEnable = Boolean(informationPopOverEnable);
  const copySingleUserData = async () => {
    setCopyUserConfirmationOpen(false);
    let paramMap = {
      sourceUserId: sourceUserName,
      destiantionUserId: destinationUserName,
      branchUserName: userName,
    };
    const response = await axios.post(
      "/specialAccessUpload/copySingleUserData",
      paramMap
    );
    setCopyUserSuccessOpen(true);
    setCopyUserButtonDisable(false);
    setSuccessDialogMessage(response.data.message);
  };

  const handleInputChange = (event, newInputValue) => {
    setNewTemplateName(event.target.value);
  };
  const handleRenderInput = (params) => (
    <TextField
      {...params}
      placeholder="Select/Create Template Name"
      variant="standard"
      onChange={(event, value) => handleInputChange(event, value)}
      InputProps={{
        ...params.InputProps,
        type: "search",
      }}
    />
  );

  const copyUserAccessDetail = (event) => {
    sourceUserName === "" && setSourceUserNameError(true);
    destinationUserName === "" && setDestiantionUserNameError(true);
    if (sourceUserName !== "" && destinationUserName !== "") {
      setCopyUserButtonDisable(true);
      setCopyUserConfirmationOpen(true);
    }
  };

  /*  const uploadAndCopyUserDetail = (event) => {
    setCopyUserButtonDisable(true);
    setCopyUserConfirmationOpen(true);
  }; */
  const uploadAndCopyUserDetail = async (event) => {
    setCopyUserButtonDisable(true);
    setCopyUserConfirmationOpen(false);
    const file = event.target.files[0];
    try {
      event.preventDefault();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("userList", userArray);
      // now reset the file.
      let element = document.getElementById("copyUploadInput");
      element.value = null;
      const response = await axios.post(
        "/specialAccessUpload/uploadAndCopyData",
        formData,
        {
          method: "POST",
          //  responseType: "blob",
        }
      );

      if (response.data.status === "OK") {
        setCopyUserSuccessOpen(true);
        setCopyUserButtonDisable(false);
        setSuccessDialogMessage(response.data.message);
      } else {
        setErrorDialogOpen(true);
        setErrorDialogMessage(response.data.message);
        setCopyUserButtonDisable(false);
      }
    } catch (error) {
      setErrorDialogOpen(true);
      setErrorDialogMessage(error);
    }
  };

  const downloadTemplateExcel = () => {
    let paramMap = {
      templateId: newTemplateName,
    };
    //selectedAreaRows["templateId"] = newTemplateName;

    try {
      axios
        .post("/specialAccessUpload/downloadTemplateExcel", paramMap, {
          headers: { "Content-Type": "application/json" },
          method: "POST",
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `SpecialAccess_Template.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          /*  setMessage("Nach Inward Sample Import File Downloaded Success.");
          setAlertType("success");
          openAlertHandler(); */
        })
        .then(() => {
          setUploadBtnDisable(false);
        });
    } catch (error) {
      /*  setMessage("Nach Inward Sample Import File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler(); */
      throw Error(error);
    }
  };
  const downloadBulkDataExcel = async () => {
    try {
      let paramMap = {
        templateId: bulkUploadTemplateName,
      };
      axios
        .post("/specialAccessUpload/downloadBulkDataExcel", paramMap, {
          headers: { "Content-Type": "application/json" },
          method: "POST",
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `SpecialAccess_BulkUpload.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          /*  setMessage("Nach Inward Sample Import File Downloaded Success.");
          setAlertType("success");
          openAlertHandler(); */
        })
        .then(() => {
          setUploadBtnDisable(false);
        });
    } catch (error) {
      /*  setMessage("Nach Inward Sample Import File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler(); */
      throw Error(error);
    }
  };
  const validateFile = () => {
    /*    let element = document.getElementById("fileUploadInput");
    element.disabled = true;
    setTimeout(function () {
      element.disabled = false;
    }, 1); */
  };
  const uploadBulkDataExcel = async (event) => {
    setUploadBtnDisable(true);
    const file = event.target.files[0];
    try {
      event.preventDefault();
      const formData = new FormData();
      formData.append("file", file);
      // now reset the file.
      let element = document.getElementById("fileBulkUploadInput");
      element.value = null;
      const response = await axios.post(
        "/specialAccessUpload/uploadBulkDataExcel",
        formData,
        {
          method: "POST",
        }
      );
      if (response.data.status === "OK") {
        setCopyUserSuccessOpen(true);
        setSuccessDialogMessage(response.data.message);
        setUploadBtnDisable(false);
      } else {
        setErrorDialogMessage(response.data.message);
        setErrorDialogOpen(true);
        setUploadBtnDisable(false);
      }
    } catch (error) {
      setUploadBtnDisable(false);
      setUploadErrorDialogOpen(true);
    }
  };
  const uploadTemplateExcel = async (event) => {
    const file = event.target.files[0];
    try {
      event.preventDefault();
      const formData = new FormData();
      formData.append("file", file);
      // now reset the file.
      let element = document.getElementById("fileTemplateUploadInput");
      element.value = null;
      const response = await axios.post(
        "/specialAccessUpload/uploadTemplateExcel",
        formData,
        {
          method: "POST",
          // responseType: "blob",
        }
      );
      if (response.data.status === "OK") {
        setCopyUserSuccessOpen(true);
        setSuccessDialogMessage(response.data.message);
        setCopyUserButtonDisable(false);
      } else {
        setErrorDialogMessage(response.data.message);
        setErrorDialogOpen(true);
        setCopyUserButtonDisable(false);
      }
    } catch (error) {
      setCopyUserButtonDisable(false);
      setUploadErrorDialogOpen(true);
    }
  };

  const getNewTemplateName = async (event, value) => {
    setNewTemplateName(value);
  };
  const handleChange = (event) => {
    setUserAccessMode(event.target.checked);
    if (event.target.checked) {
      setUserAccessModeValue("Append");
    } else {
      setUserAccessModeValue("Fresh");
    }
  };

  return (
    <>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          item
          container
          spacing={2}
          // columns={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6 }}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          {" "}
          <AccordianContainer
            id="accord-intial"
            title="Special Access Operations"
            initialOpen={true}
          >
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="userAccess"
                control={<Radio />}
                label="User Access"
                onChange={getUserAccessDetails}
              />

              <FormControlLabel
                value="copyUser"
                control={<Radio />}
                label="Copy User"
                onChange={copyUserDetail}
              />

              <FormControlLabel
                value="create Template"
                control={<Radio />}
                label="Create Template"
                onChange={createTemplateAccessDetail}
              />
              <FormControlLabel
                value="upload"
                control={<Radio />}
                label="Bulk Upload"
                onChange={uploadAccessDetail}
              />
            </RadioGroup>
          </AccordianContainer>
          {userAccessEnable && (
            <AccordianContainer
              id="accord-jv"
              title="User Access Details"
              initialOpen={userAccessEnable}
            >
              <Box id="accord-box-jv-create" component="form" validate="True">
                <Grid container spacing={1}>
                  <Grid
                    id="grid-container"
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={2.4}
                    xl={2.4}
                  >
                    <CustomAutoComplete
                      required={true}
                      label="User"
                      id="user"
                      variant="standard"
                      value={screenUserName}
                      onChange={(event, newValue) =>
                        getModuleValues(event, newValue)
                      }
                      type="text"
                      placeholder="Select User"
                      autoCompleteValues={userArray}
                    />
                    {userNameError && (
                      <p className="error">Please Select User</p>
                    )}
                  </Grid>
                  <Grid
                    className="template-list"
                    xs={12}
                    sm={6}
                    md={6}
                    lg={2.4}
                    xl={2.4}
                  >
                    <CustomAutoComplete
                      label="Template Name"
                      id="template-details"
                      variant="standard"
                      disabled={templateDisabled}
                      value={initialTemplate}
                      onChange={(event, newValue) =>
                        getTemplateUser(event, newValue)
                      }
                      type="text"
                      placeholder="Select Template Name"
                      autoCompleteValues={templateValue}
                    />
                  </Grid>
                  <Grid
                    id="grid-container"
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={2.4}
                    xl={2.4}
                  >
                    <CustomAutoComplete
                      label="Module List"
                      id="moduleList"
                      variant="standard"
                      value={moduleName}
                      disabled={disableModule}
                      onChange={(event, newValue) =>
                        getModuleNameDetails(event, newValue)
                      }
                      type="text"
                      placeholder="Select Module Name"
                      autoCompleteValues={moduleHeaderList}
                    />
                  </Grid>
                  <Grid
                    id="grid-container"
                    xs={12}
                    sm={6}
                    md={6}
                    lg={2.4}
                    xl={2.4}
                  >
                    <Box
                      sx={{
                        margin: "32px 4px 0px 4px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip title="Ctrl+F" placement="top">
                        <Button
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            height: "2rem",
                          }}
                          variant="contained"
                          onClick={(event) => handleSearch(event)}
                          ref={searchButtonRef}
                        >
                          Go
                        </Button>
                      </Tooltip>
                      <Tooltip title="Ctrl+S" placement="top">
                        <Button
                          disabled={saveDisabled}
                          sx={{
                            marginLeft: "8px",
                            color: "white",

                            fontWeight: "bold",
                            height: "1rem",
                          }}
                          onMouseOver={({ target }) => {
                            target.style.backgroundColor = "#004a92";
                            target.style.color = "white";
                          }}
                          variant="contained"
                          onClick={saveData}
                          ref={saveRef}
                        >
                          {"Save"}
                        </Button>
                      </Tooltip>
                      <Tooltip title="Ctrl+D" placement="top">
                        <Button
                          sx={{
                            marginLeft: "8px",
                            color: "white",
                            backgroundColor: "black",
                            fontWeight: "bold",
                            cursor: "pointer",
                            height: "2rem",
                          }}
                          onMouseOver={({ target }) => {
                            target.style.backgroundColor = "black";
                            target.style.color = "white";
                          }}
                          variant="contained"
                          onClick={() => clearButtonClickHandler()}
                          ref={clearRef}
                        >
                          Clear
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                  <Grid
                    id="append-container"
                    item
                    xs={12}
                    sm={6}
                    md={2.4}
                    lg={2.4}
                    xl={2.4}
                  >
                    <Box
                      sx={{
                        margin: "20px 12px 0px 4px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Grid
                        component="label"
                        container
                        alignItems="center"
                        spacing={1}
                        display={displayUserAccessMode}
                      >
                        <Grid item>Fresh</Grid>
                        <Grid item>
                          <Switch
                            checked={userAccessMode}
                            onChange={handleChange}
                            disabled={userAccessModeDisable}
                          />
                        </Grid>
                        <Grid item>Append</Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {gridVisible && (
                <Box
                  id="accord-jv"
                  sx={{
                    color: "red",
                    background: "white",
                    padding: "0.8rem",
                    borderRadius: "0.4rem",
                    width: "100%",
                  }}
                >
                  <div className="overall-box">
                    <Grid id="grid-container" item md={6} lg={6} xl={6}>
                      <div>
                        <h4>Module Access Details</h4>
                      </div>
                      <CustomDataGrid
                        noDataMessage="No Module Data"
                        noDataOnFilterMessage="No Module on Applied Module Filter"
                        rows={moduleRowList}
                        columns={moduleColumns}
                        pageSize={3}
                        pageSizeOptions={[5]}
                        rowHeight={40}
                        gridHeight={
                          moduleRowList.length < 5 && moduleRowList.length !== 0
                            ? moduleRowList.length * 40 + 110
                            : 230
                        }
                        onCellEditCommit={(event) => getProgramValues(event)}
                        isCellEditable={() => true}
                      />
                    </Grid>

                    <Box>
                      {programGridVisible && (
                        <Grid item container spacing={2}>
                          <Grid
                            id="grid-container"
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                          >
                            <div className="program-header">
                              <h4>Program Access Details</h4>
                            </div>
                            <CustomDataGrid
                              noDataMessage="No Program Data"
                              noDataOnFilterMessage="No Programs on Applied Module Filter"
                              rows={programRowList}
                              columns={programColumn}
                              pageSize={3}
                              pageSizeOptions={[5]}
                              rowHeight={40}
                              gridHeight={
                                programRowList.length < 5 &&
                                programRowList.length !== 0
                                  ? programRowList.length * 40 + 110
                                  : 230
                              }
                              onCellEditCommit={(event) => getModeValues(event)}
                              isCellEditable={() => true}
                            />
                          </Grid>

                          <Grid
                            id="grid-container"
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                          >
                            {modeGridEnable && (
                              <>
                                <div className="program-header">
                                  <h4>Mode Access Details</h4>
                                </div>
                                <CustomDataGrid
                                  noDataMessage="No Mode Data"
                                  noDataOnFilterMessage="No Mode on Applied Program Filter"
                                  rows={modeRowList}
                                  columns={modeColumn}
                                  pageSize={
                                    modeRowList.length > 3
                                      ? 3
                                      : modeRowList.length
                                  }
                                  rowHeight={40}
                                  pageSizeOptions={[5]}
                                  gridHeight={
                                    modeRowList.length < 5 &&
                                    modeRowList.length !== 0
                                      ? modeRowList.length * 40 + 110
                                      : 230
                                  }
                                  onCellEditCommit={(event) =>
                                    getFieldValues(event)
                                  }
                                  isCellEditable={() => true}
                                />
                              </>
                            )}
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                    {fieldGridVisible && (
                      <Grid item container spacing={2}>
                        <Grid
                          id="grid-container"
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          <div className="program-header">
                            <h4>Field Access Details</h4>
                          </div>
                          <CustomDataGrid
                            noDataMessage="No Field Data"
                            noDataOnFilterMessage="No Field Data on Applied Screen"
                            rows={filedRowList}
                            columns={fieldColumn}
                            pageSize={3}
                            pageSizeOptions={[5]}
                            rowHeight={40}
                            gridLazyLoad={() => {}}
                            isCellEditable={() => true}
                            gridHeight={
                              filedRowList.length < 5 &&
                              filedRowList.length !== 0
                                ? filedRowList.length * 40 + 110
                                : 230
                            }
                            onCellEditCommit={(event) => getParamValues(event)}
                          />
                        </Grid>
                        <Grid
                          id="grid-container"
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                        >
                          {paramGridEnable && (
                            <>
                              <div className="program-header">
                                <h4>Param Access Details</h4>
                              </div>
                              <CustomDataGrid
                                noDataMessage="No param Data"
                                noDataOnFilterMessage="No Param Data on Applied Screen"
                                rows={paramRowList}
                                columns={paramColumn}
                                pageSize={3}
                                rowHeight={40}
                                pageSizeOptions={[5]}
                                gridLazyLoad={() => {}}
                                isCellEditable={() => true}
                                gridHeight={
                                  paramRowList.length < 5 &&
                                  paramRowList.length !== 0
                                    ? paramRowList.length * 40 + 105
                                    : 230
                                }
                                onCellEditCommit={(event) =>
                                  setMapToSave(event)
                                }
                              />
                            </>
                          )}
                        </Grid>
                      </Grid>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "13px",
                        marginBottom: "4px",
                      }}
                    ></Box>
                  </div>
                </Box>
              )}
            </AccordianContainer>
          )}
          {copyUserEnable && (
            <Grid item container spacing={1}>
              <AccordianContainer
                id="copy-user"
                title="Copy User Data"
                initialOpen={copyUserEnable}
              >
                <Box>
                  <Grid item container spacing={1}>
                    <Grid
                      id="grid-container"
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={3}
                      xl={3}
                    >
                      <CustomAutoComplete
                        required={true}
                        label="Source User"
                        id="source-user"
                        variant="standard"
                        value={sourceUserName}
                        onChange={(event, newValue) =>
                          getSourceUserName(event, newValue)
                        }
                        type="text"
                        placeholder="Select Source User"
                        autoCompleteValues={userArray}
                      />
                      {sourceUserNameError && (
                        <p className="error">Please Select Source User</p>
                      )}
                    </Grid>
                    <Grid
                      id="grid-container"
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={3}
                      xl={3}
                    >
                      <CustomAutoComplete
                        required={true}
                        label="Destination User"
                        id="destination-user"
                        variant="standard"
                        value={destinationUserName}
                        onChange={(event, newValue) =>
                          getDestinationUser(event, newValue)
                        }
                        type="text"
                        placeholder="Select Destination User"
                        autoCompleteValues={userArray}
                      />
                      {destiantionUserNameError && (
                        <p className="error">Please Select Destination User</p>
                      )}
                    </Grid>
                    <Grid id="grid-container" item>
                      <Box
                        sx={{
                          margin: "32px 4px 0px 4px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Ctrl+S" placement="top">
                          <Button
                            sx={{
                              fontWeight: "bold",
                              cursor: "pointer",
                              height: "2rem",
                            }}
                            variant="contained"
                            disabled={copyUserButtonDisable}
                            onClick={(event) => copyUserAccessDetail(event)}
                            ref={saveCopyRef}
                          >
                            Copy
                          </Button>
                        </Tooltip>
                        <Tooltip title="Ctrl+D" placement="top">
                          <Button
                            sx={{
                              marginLeft: "8px",
                              color: "white",
                              backgroundColor: "black",
                              fontWeight: "bold",
                              cursor: "pointer",
                              height: "2rem",
                            }}
                            onMouseOver={({ target }) => {
                              target.style.backgroundColor = "black";
                              target.style.color = "white";
                            }}
                            variant="contained"
                            onClick={() => clearUserAccessDetail()}
                            ref={clearCopyRef}
                          >
                            Clear
                          </Button>
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "8px",
                        marginTop: "29px",
                      }}
                    >
                      <Grid
                        sx={{
                          marginTop: "5px",
                          marginLeft: "28px",
                          fontWeight: "bold",
                        }}
                      >
                        <label>Bulk Copy</label>
                      </Grid>
                      <Tooltip title="Download(Ctrl+J)" placement="top">
                        <Button
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            height: "2rem",
                            marginLeft: "1rem",
                            alignItems: "center",
                          }}
                          variant="contained"
                          disabled={false}
                          onClick={(event) => downloadCopyValuesTemplate(event)}
                          ref={downloadCopyRef}
                        >
                          <FileDownloadIcon></FileDownloadIcon>
                        </Button>
                      </Tooltip>

                      <Tooltip title="Upload and Save(Ctrl+U)" placement="top">
                        <Button
                          variant="contained"
                          component="label"
                          disabled={copyUserButtonDisable}
                          sx={{
                            height: "2rem",
                            fontWeight: "bold",
                            align: "center",
                            marginLeft: "12px",
                            alignItems: "center",
                          }}
                          onClick={validateFile}
                          ref={uploadCopyRef}
                        >
                          <input
                            hidden
                            id="copyUploadInput"
                            accept=".xlsx"
                            type="file"
                            sx={{ height: "2rem" }}
                            onChange={uploadAndCopyUserDetail}
                          />
                          <FileUploadIcon></FileUploadIcon>
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </Box>
              </AccordianContainer>
            </Grid>
          )}
          {createTemplateEnable && (
            <Grid item container spacing={1}>
              <AccordianContainer
                id="create-template"
                title="Select/Create Template"
                initialOpen={createTemplateEnable}
              >
                <Box>
                  <Grid item container spacing={1}>
                    <Grid
                      id="grid-container"
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={3}
                      xl={3}
                    >
                      <InputLabel
                        size="small"
                        sx={{
                          color: "#004A92",
                          mb: 2,
                          fontWeight: 400,
                          fontSize: "14px",
                        }}
                      >
                        {"Select/Create Template Name"}
                      </InputLabel>
                      <Autocomplete
                        sx={{}}
                        freeSolo
                        disableClearable
                        id="createtempalte"
                        value={newTemplateName}
                        disabled={false}
                        onChange={(event, value) => {
                          getNewTemplateName(event, value);
                        }}
                        options={templateValue}
                        renderInput={handleRenderInput}
                      />
                    </Grid>
                    <Box
                      sx={{
                        marginTop: "31px",
                        marginLeft: "-14px",
                      }}
                    >
                      <Tooltip title="Template Info" placement="top">
                        <Button
                          sx={{
                            cursor: "pointer",
                            height: "2rem",

                            alignItems: "center",
                          }}
                          disabled={false}
                          onClick={getTemplateInfo}
                        >
                          <InfoRoundedIcon />
                        </Button>
                      </Tooltip>
                      <Popover
                        id="info-popover"
                        open={informationPopOverEnable}
                        anchorEl={informationPopOverEnable}
                        onClose={() => setInformationPopOverEnable(null)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <Typography sx={{ p: 2 }}>
                          Need to Select/Create the Template Name in the
                          selection. Else Default Full_Access will be taken as
                          Template Name
                        </Typography>
                      </Popover>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "8px",
                        marginTop: "29px",
                      }}
                    >
                      <Tooltip
                        title=" Download Template(Ctrl+J)"
                        placement="top"
                      >
                        <Button
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            height: "2rem",
                            marginLeft: "1rem",
                            alignItems: "center",
                          }}
                          variant="contained"
                          disabled={false}
                          onClick={(event) => downloadTemplateExcel(event)}
                          ref={downloadTemplateRef}
                        >
                          <FileDownloadIcon></FileDownloadIcon>
                        </Button>
                      </Tooltip>

                      <Tooltip title="Upload and Save(Ctrl+U)" placement="top">
                        <Button
                          variant="contained"
                          component="label"
                          disabled={uploadTemplateBtnDisable}
                          sx={{
                            height: "2rem",
                            fontWeight: "bold",
                            align: "center",
                            marginLeft: "12px",
                            alignItems: "center",
                          }}
                          onClick={validateFile}
                          ref={uploadTemplateRef}
                        >
                          <input
                            hidden
                            id="fileTemplateUploadInput"
                            accept=".xlsx"
                            type="file"
                            sx={{ height: "2rem" }}
                            onChange={uploadTemplateExcel}
                          />
                          <FileUploadIcon></FileUploadIcon>
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </Box>
              </AccordianContainer>
            </Grid>
          )}
          {uploadEnable && (
            <AccordianContainer
              id="accord-upload"
              title=" Bulk Upload User Access"
              initialOpen={uploadEnable}
            >
              <Box>
                <Grid item container spacing={1}>
                  <Grid
                    id="grid-container"
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={3}
                    xl={3}
                  >
                    <CustomAutoComplete
                      label="Template Name"
                      id="template-details"
                      variant="standard"
                      disabled={false}
                      value={bulkUploadTemplateName}
                      onChange={(event, newValue) =>
                        bulkUploadTemplateUser(event, newValue)
                      }
                      // required={true}
                      type="text"
                      placeholder="Select Template Name"
                      autoCompleteValues={templateValue}
                    />
                  </Grid>
                  <Box
                    sx={{
                      marginTop: "31px",
                      marginLeft: "-14px",
                    }}
                  >
                    <Tooltip title="Template Info" placement="top">
                      <Button
                        sx={{
                          cursor: "pointer",
                          height: "2rem",

                          alignItems: "center",
                        }}
                        disabled={false}
                        onClick={getTemplateInfo}
                      >
                        <InfoRoundedIcon />
                      </Button>
                    </Tooltip>
                    <Popover
                      id="info-popover"
                      open={informationPopOverEnable}
                      anchorEl={informationPopOverEnable}
                      onClose={() => setInformationPopOverEnable(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <Typography sx={{ p: 2 }}>
                        Need to Select the Template Name in the selection. Else
                        Default Full_Access will be taken as Template Name
                      </Typography>
                    </Popover>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "8px",
                      marginTop: "29px",
                    }}
                  >
                    <Tooltip title="Bulk Download(Ctrl+J)" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                          marginLeft: "1rem",
                          alignItems: "center",
                        }}
                        variant="contained"
                        disabled={false}
                        onClick={(event) => downloadBulkDataExcel(event)}
                        ref={downloadBulkRef}
                      >
                        <FileDownloadIcon></FileDownloadIcon>
                      </Button>
                    </Tooltip>

                    <Tooltip title="Bulk Upload(Ctrl+U)" placement="top">
                      <Button
                        variant="contained"
                        component="label"
                        disabled={uploadBtnDisable}
                        sx={{
                          height: "2rem",
                          fontWeight: "bold",
                          align: "center",
                          marginLeft: "12px",
                          alignItems: "center",
                        }}
                        onClick={validateFile}
                        ref={uploadBulkRef}
                      >
                        <input
                          hidden
                          id="fileBulkUploadInput"
                          accept=".xlsx"
                          type="file"
                          sx={{ height: "2rem" }}
                          onChange={uploadBulkDataExcel}
                        />
                        <FileUploadIcon></FileUploadIcon>
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Box>
            </AccordianContainer>
          )}
        </Grid>
        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Save Special Access Details ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            onSaveButtonClickHandler();
          }}
          onDialogClose={() => {
            setSaveDialogOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={goConfirmationDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={
            "The Current Module Access has Changes. Are you sure want to Proceed?"
          }
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            goButtonAction();
          }}
          onDialogClose={() => {
            setGoConfirmationDialogOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={discardDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are you sure you want to Clear Changes ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            discardChange();
          }}
          onDialogClose={() => {
            setDiscardDialogOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={saveSuccessDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                Special Access Changes saved successfully.
              </Typography>
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={copyUserConfirmationOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are You Sure to Copy User Details?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={copySingleUserData}
          onDialogClose={() => {
            setCopyUserButtonDisable(false);
            setCopyUserConfirmationOpen(false);
          }}
        />
        <CustomConfirmationDialog
          dialogOpen={uploadInformationDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                Data Uploaded Successfully.
              </Typography>
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={uploadErrorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                Failed to upload the data.please check the file.
              </Typography>
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => setUploadErrorDialogOpen(false)}
        />
        <CustomConfirmationDialog
          dialogOpen={copyUserSuccessOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                {successDialogMessage}
              </Typography>
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              {emptyValueFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some record is empty in the table
                </Typography>
              )}
              {duplicateFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some duplicate record in the table
                </Typography>
              )}
              {errorDialogOpen && (
                <Typography sx={{ fontSize: "1rem" }}>
                  {errorDialogMessage}
                </Typography>
              )}
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => setErrorDialogOpen(false)}
        />
      </div>
      <CustomSnackBar
        showSnackbar={showSnackBar}
        autoHideDuration={5000}
        onClose={() => {
          setShowSnackBar(false);
        }}
        message={snackBarMessage}
        severity="error"
      />
      <StlapFooter />
    </>
  );
};
export default SpecialFunctionAccess;
